export const Colors = {
  KIHADA: "#FBE251",
  TOHOH: "#F05454",
  YAMABUKI: "#FFB11B",
  OHNI: "#D9D9D9",
  WHITE: "#FFFFFF",
  BLACK: "#000000",
};
